<template>
  <a-modal
    v-model="showModal"
    class="mobile-modal-fullscreen"
    :footer="null"
    :closable="false"
    :bodyStyle="{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '24px', gap: '24px', position: 'relative', 'min-height': '828px' }"
    width="587px"
  >
    <div class="w-100" v-if="flag">
      <div class="header" v-if="!loading">
        <div class="close-mob">
          <img src="../../assets/images/xmark.png" class="xmark" @click="handleCancel()" />
        </div>
        <span class="title">Image Categories</span>
        <div class="close">
          <img src="../../assets/images/xmark.png" class="xmark" @click="handleCancel()" />
        </div>
      </div>
      <div :style="{ 'min-height': '100px' }" v-if="loading">
        <div :style="{ top: '50%', left: '50%' }" class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div v-if="subImageCategories.length > 0 && !loading" class="condition-container">
        <div class="grid-container">
          <div v-for="subCat in subImageCategories" :key="subCat.id" @click="getBackgroundImages(subCat)" class="grid-item">
            <a-avatar
              class="avatar"
              :style="{ color: ' #ffffff !important', 'background-color': getPrimaryColor() }"
              :src="subCat.background_image && subCat.background_image[0].thumbnail_url ? subCat.background_image[0].thumbnail_url : null"
            >
            </a-avatar>
            <span class="category-title">{{ subCat.display_name }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- images in category -->
    <div v-else>
      <div class="header" v-if="!loading">
        <span :style="{ marginRight: '24px' }" @click="handleback"><font-awesome-icon size="lg" class="xmark" :icon="['far', 'arrow-left']"/></span>
        <span class="title">{{ selectedCategory }}</span>
        <div @click="handleCancel()" class="close">
          <font-awesome-icon size="1x" class="xmark" :icon="['far', 'times']" />
        </div>
        <button class="apply-filter-btn-mob" :style="{ background: getPrimaryColor() }" @click="save()">Submit</button>
      </div>
      <div :style="{ 'min-height': '100px' }" v-if="loading">
        <div :style="{ top: '50%', left: '50%' }" class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div v-if="images.length > 0 && !loading" class="condition-container">
        <div class="grid-container">
          <div v-for="image in images" :key="image.id" @click="selectImage(image)" class="grid-item">
            <a-avatar class="avatar" :style="{ color: ' #ffffff !important', 'background-color': getPrimaryColor() }" v-if="!loading" :src="image.thumbnail_url"> </a-avatar>
            <div v-if="image.file_name === selectedImage" class="avatar_select_overlay" :style="{ 'background-color': getPrimaryColor() }">
              <font-awesome-icon size="2x" :icon="['fas', 'check']" />
            </div>
            <span class="category-title">{{ image.display_name }}</span>
          </div>
        </div>
      </div>
      <div v-if="images.length > 0 && !loading" class="footer">
        <button class="cancel-btn" @click="handleCancel()">Cancel</button>
        <button class="apply-filter-btn" :style="{ background: getPrimaryColor() }" @click="save()">Save</button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import { faArrowLeft, faTimes } from "@fortawesome/pro-regular-svg-icons"
import { faCheck } from "@fortawesome/pro-solid-svg-icons"
import { library } from "@fortawesome/fontawesome-svg-core"

library.add(faArrowLeft, faTimes, faCheck)
const UserRepository = RepositoryFactory.get("user")
const AppRepository = RepositoryFactory.get("app")

export default {
  name: "ProfileImageGallery",
  data() {
    return {
      showModal: false,
      images: [],
      imageCategories: [],
      subImageCategories: [],
      category: "",
      subCategory: "",
      selectedImage: null,
      loading: false,
      flag: true,
      screenSize: null,
      isBackgroundImageLoading: false,
      // initialCategory:null,
      selectedCategory: null,
    }
  },
  created() {
    this.screenSize = window.innerWidth
  },

  props: {
    handleLoader: Function,
  },

  methods: {
    onLoadHandler: function() {
      this.isBackgroundImageLoading = false
    },

    handleback() {
      this.flag = true
      this.selectedImage = null
    },

    show(data) {
      this.showModal = true
      // this.getImageCategories();
      this.getImageSubCategories()
    },
    hide() {
      this.showModal = false
    },

    selectImage(image) {
      // this.selectedImage = image.id;
      this.selectedImage = image.file_name
    },

    getImageCategories() {
      this.loading = true
      AppRepository.getImageCategories()
        .then(res => {
          this.imageCategories = res.data.data
          this.initialCategory = this.imageCategories[0].id
        })
        .catch(err => {
          this.loading = false
          this.images = []
          this.selectedImage = null
        })
    },

    getImageSubCategories() {
      this.loading = true
      AppRepository.getImageSubCategories(window.location.origin.includes("stage") ? 301 : 286)
        // for stage prev : 285 id -> 301
        .then(res => {
          this.subImageCategories = res.data.data
          this.images = []
          this.selectedImage = null
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.images = []
          this.selectedImage = null
        })
    },

    getBackgroundImages(cat) {
      this.flag = false
      this.loading = true
      this.selectedCategory = cat.display_name
      AppRepository.getBackgroundImageGallery(cat.id)
        .then(res => {
          this.images = res.data.data
          this.selectedImage = null
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.images = []
          this.selectedImage = null
        })
    },

    async save() {
      console.log("save()")
      this.hide()
      this.handleLoader(true)
      this.loading = true
      const payload = { file_name: this.selectedImage }
      try {
        await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        const authUserData = updateData.data.data.user_info
        this.$store.commit("User/setAuthUserProfileImg", authUserData)
        this.handleLoader(false)
        this.$store.commit("Posts/setPercent", true)
        this.flag = true
        this.$notification.success({ message: "Success", description: "Image added successfully" })
      } catch (err) {
        this.handleLoader(false)
        this.loading = false
      }
    },

    handleCancel() {
      this.showModal = false
      this.flag = true
    },
  },
}
</script>

<style lang="scss" scoped>
//new modal css

.avatar:hover {
  background: #2a71d4;
  opacity: 0.5;
}

.avatar {
  width: 100%;
  height: 100%;
}

.apply-filter-btn-mob {
  display: none;
  @media screen and (max-width: 700px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    width: 93px;
    height: 48px;
    // background: #2a71d4;
    border-radius: 6px;
    text-transform: capitalize;
    color: #ffffff;
    border: none;
    cursor: pointer;
  }
}

.apply-filter-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 78px;
  height: 48px;
  background: #2a71d4;
  border-radius: 6px;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
  cursor: pointer;
}

.cancel-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 91px;
  height: 48px;
  background: #e2e8f0;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #47556e;
  border: none;
  cursor: pointer;
}

.footer {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 10px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.category-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  color: #33415f;
}

.grid-item {
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 24px;
  @media screen and (max-width: 500px) {
    // display: flex;
    // flex-wrap: wrap;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 7px;
  }
}
.condition-container {
  margin-top: 21px;
  width: 100%;
  height: 727px;
  overflow-y: scroll;
  @media screen and (max-width: 700px) {
    margin-top: 40px;
  }
}

.condition-container::-webkit-scrollbar {
  width: 0 !important;
}
.close {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 0px;
  // width: 480px;
  height: 24px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.close-mob {
  display: none;
  @media screen and (max-width: 700px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    padding: 0px;
    margin-right: 10px;
    // height: 24px;
  }
}

.xmark {
  cursor: pointer;
  color: #94a3b8;
}
.title {
  width: 100%;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #33415f;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;

  // width: 539px;
  // height: 29px;
}

.modalContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  position: relative;
  width: 587px;
  height: 529px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.ant-modal-content {
  border-radius: 8px;
}

.fw700 {
  font-weight: 700;
}

.mainHeading {
  font-size: 24px;
  line-height: 32px;
  color: #33415f !important;
}

.subHeading {
  font-size: 16px;
  line-height: 32px;
  color: #647490 !important;
  margin-top: 45px;
}

.checkbox,
.checkboxMain {
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-weight: 400;
  font-size: 34px;
  line-height: 21px;
  color: #0f1734 !important;
}

.btn {
  border-radius: 6px;
  font-size: 14px;
  line-height: 24px;
}

.cancel {
  background: #e2e8f0;
  width: 91px;
  height: 48px;

  .cancelColor {
    color: #47556e !important;
  }
}

.apply {
  background: #2a71d4;
  width: 128px;
  height: 48px;

  .applyColor {
    color: #ffffff !important;
  }
}

////old modal css
.image-container {
  cursor: pointer;
  position: relative;
  img {
    width: 100%;
    min-height: 100px;
  }
  .fa-check-circle {
    position: absolute;
    top: 0.1rem;
    right: 0.1rem;
    font-size: 25px;
  }
}

.row {
  height: 400px;
  overflow-y: scroll;
}

@media screen and (max-width: 581px) {
  .row {
    overflow-y: scroll;
    max-height: 500px;
  }
}

.avatar_select_overlay {
  width: 100%;
  height: 95%;
  position: absolute;
  color: #ffffff !important;
  background-color: #2a71d4;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/ProfileImageGallery.vue